import React from 'react'
import './Ministries.css'
import '../../../App.css'
import '../SubLinks.css'
import MinistryLinks from '../MinistryLinks';
import { Link } from 'react-router-dom'

function Women() {
    return (
        <div>
            <div className='hero-container women half'>
                <h1></h1>
            </div>
        <div className='main-grid-container'>
          <div className='main-grid-item'>
        <MinistryLinks/>
        </div>
        <div className='main-grid-item'>
        <div className='main with-sublinks'>
                <h1>Women of the Word</h1>

                <div className='blockquote-container'>
                    <blockquote> Charm is deceitful and beauty is vain, but a woman who fears Yahweh, she shall be praised.
                        <cite> - Proverbs 31:30</cite>
                    </blockquote>
                    </div>                
                <p>
                Grace Community Fellowship women enjoy gathering for time together in God’s Word, prayer and fellowship. Their lives are defined by care for one another, working to grow in the grace and knowledge of our Lord and Savior Jesus Christ and understanding and fulfilling the unique role God has ordained for women in the family, the church, and the community.<br/><br/>
                </p>
                <h3>Discipleship Opportunities Include:</h3>
                    <ul className='ul-ministries'>
                    <li>Women of the Word - Bible Studies</li>
                    <li>Titus 2 - Leadership Training</li>
                    <li>Mom's Group</li>
                    <li>Personal Discipleship & Counseling</li>
                    <li>Conferences</li>
                    <li>Annual Christmas Tea</li>
                    </ul>
                <br/>
                
                <p>
                If you are interested in learning more about our Women's Ministry please <Link to='/contact-us' className='p-link'>contact us</Link>.
                </p>
            </div>

        </div>
        </div>
        </div>
    )
}

export default Women
